
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/[orgId]/settings",
      function () {
        return require("private-next-pages/dashboard/[orgId]/settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/[orgId]/settings"])
      });
    }
  